/*
 * @Author: liujunhong
 * @Date: 2023/7/3
 * @Desc: 请求url
 */


import { MAP_SITE_URL } from '@/constants';
import { post } from '@/utils/request';
const {API_ACCOUNT_URL, API_SECURITY_URL, API_APIJ_URL} = MAP_SITE_URL;
import { Investigation } from '@/types'

/**
 * 用户信息
 */
export const getAccountInfo = `${API_ACCOUNT_URL}/about/account/userSecurityInfo`;

// 自助封停&解封
export const closureUrl = `${API_SECURITY_URL}/v1/security/gameblock/weGameCheck`;

// 确认封停
export const qrBlockApi = (params: {guidId: string, uuid: string}) => {
    return post(`${API_SECURITY_URL}/v1/security/gameblock/qrBlock?guildId=${params.guidId}&uuid=${params.uuid}`);
};

// 确认封停
export const qrUnSelfApi = (params: {guidId: string, uuid: string}) => {
    return post(`${API_SECURITY_URL}/v1/security/gameblock/qrUnnSeal?guildId=${params.guidId}&uuid=${params.uuid}`);
};

// 检查wegame用户绑定app天数
export const checkWeGameBindDays = `${API_SECURITY_URL}/v1/security/gameblock/checkWeGameBindDays`;

// wegame用户查询提交问题个数
export const getQuestionCount = `${API_APIJ_URL}/wegame/getQuestionCount`;

// 获取最近一条工单信息状态
export const getLastQuestionDetail = `${API_APIJ_URL}/wegame/getLastQuestionDetail`;

// wegame用户查询问题列表
export const getQuestionList = `${API_APIJ_URL}/wegame/workorder/getquestionlist`;

// 获取工单详细信息
export const getDetail = `${API_APIJ_URL}/wegame/workorder/detail`;

// 提交服务评价
export const investigation = (params: Investigation) => {
    return post(`${API_APIJ_URL}/wegame/workorder/investigation`, params);
};

/**
 * 获取被盗物品原因
 */
export const getItemsStolenReasons =  `${API_APIJ_URL}/wegame/workOrder/itemsRecovered/getItemsStolenReasons`;
